// Ryan agreed to not bringing new lib to UI and just take everything after `@`
export const getCompanyDomainFromEmail = email => email.substring(email.lastIndexOf('@') + 1);
